import type { VfConfig } from '#types/config/components/vf'

export default {
  fallbackSizes: {
    md: 'sm',
    tiny: 'xs'
  },
  fallbackVariants: {
    'tertiary': 'secondary',
    'tertiary-inverse': 'secondary-inverse'
  },
  sizes: ['xs', 'sm'],
  variants: [
    'primary',
    'primary-inverse',
    'secondary',
    'secondary-inverse'
  ]
} satisfies VfConfig['button']
